import { Box, Chip, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

const DEFAULT_LANE = { id: "0", name: "Sem lane", color: "#757575" };

export function KanbanFilter({ onFiltered }) {
  const [lanes, setLanes] = useState([]);
  const [selecteds, setSelecteds] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const { data } = await api.get("/tag/kanban");
        const list = Array.isArray(data) ? data : data?.lista || data?.tags || [];
        setLanes([DEFAULT_LANE, ...list]);
      } catch (err) {
        toastError(err);
      }
    }
    fetchData();
  }, []);

  const onChange = (value) => {
    setSelecteds(value);
    onFiltered(value);
  };

  return (
    <Box style={{ width: "100%" }}>
      <Autocomplete
        multiple
        size="small"
        options={lanes}
        value={selecteds}
        onChange={(e, v) => onChange(v)}
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => String(option.id) === String(value.id)}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              style={{
                backgroundColor: option.color || "#eee",
                textShadow: "1px 1px 1px #000",
                color: "white",
              }}
              label={option.name}
              {...getTagProps({ index })}
              size="small"
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={i18n.t("tickets.search.filterKanban") || "Etapas Kanban"}
          />
        )}
      />
    </Box>
  );
}
